import Header from "@/components/Header";
import Footer from "@/components/Footer";

/**
 * Reusable page shell — the visual chrome (Header + main + Footer) shared by
 * every non-homepage route. Keeps the existing design language (obsidian
 * background + neon accents) intact.
 */
export default function PageShell({ children, testId }) {
  return (
    <div className="min-h-screen relative z-10" data-testid={testId}>
      <Header />
      <main className="pt-32 pb-24 px-4 max-w-4xl mx-auto">{children}</main>
      <Footer />
    </div>
  );
}
